import { RefObject } from 'react';

import { cn } from 'noddi-ui-common';
import { useHover } from '../../../hooks';

type Props = {
  parentRef: RefObject<HTMLElement>;
};

export const ExpandingArrow = ({ parentRef }: Props) => {
  const isHovered = useHover(parentRef);

  return (
    <div className='relative flex w-5 items-center'>
      <svg
        viewBox='0 0 16 16'
        className={cn('absolute size-4 transition-all', isHovered ? 'opacity-0' : 'opacity-100')}
      >
        <path
          fillRule='evenodd'
          d='M6.22 3.22a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 010-1.06z'
        />
      </svg>
      <svg
        viewBox='0 0 16 16'
        className={cn('absolute size-4 transition-all', isHovered ? 'opacity-100' : 'opacity-0')}
      >
        <path
          fillRule='evenodd'
          d='M8.22 2.97a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06l2.97-2.97H3.75a.75.75 0 010-1.5h7.44L8.22 4.03a.75.75 0 010-1.06z'
        />
      </svg>
    </div>
  );
};
